import { CMSPageView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/cmsPage.template'
import { Pageheader } from '@shared/Frontend/components/pageheader'
import { PublicationMeta } from '@shared/Frontend/components/publicationMeta'
import { useDocumentTitleEffect } from '@shared/Frontend/hooks/useDocumentTitleEffect'
import { getSite } from '@shared/Frontend/utils/site'
import React, { ReactNode } from 'react'

const site = getSite()

export const CMSPage: CMSPageView['CMSPage'] = ({ metaTitle, breadcrumbs, header, children, ...rest }) => {
  useDocumentTitleEffect(metaTitle)
  return (
    <>
      <Pageheader breadcrumbs={breadcrumbs} kind={rest.kind} {...header} />
      {rest.variety === 'overview'
        ? <CMSPageOverview header={header} {...rest}>{children}</CMSPageOverview>
        : <CMSPageContent header={header} {...rest}>{children}</CMSPageContent>
      }
    </>
  )
}

type OverviewProps = Extract<Parameters<CMSPageView['CMSPage']>[0], { variety: 'overview' }> & { children: ReactNode }

const CMSPageOverview = ({ children, ...rest }: OverviewProps) => {
  const gridOrListClass = rest.gridOrList !== undefined ? (rest.gridOrList ? '--grid' : '--teasers') : ''

  if (site === 'ZEG') return (
    <div className={`overview overview--${gridOrListClass} ls-gutter`}>
      <div className="overview__inner ls-container--l">
        <div className="overview__layout ls-container ls-spacing ls-gutter">
          {children}
        </div>
      </div>
    </div>
  )

  return (
    <div className={`overview overview--${rest.type}${gridOrListClass} ls-spacing`}>
      <div className="overview__inner ls-container ls-gutter">
        <div className="overview__layout">{children}</div>
      </div>
    </div>
  )
}

type ContentProps = Extract<Parameters<CMSPageView['CMSPage']>[0], { variety: 'other' }> & { children: ReactNode }

const CMSPageContent = ({ header, children, sidebar, ...rest }: ContentProps) => {
  if (site !== 'ZEG') return <>{children}</>

  return (
    <div className='page__outer'>
      <div className="page__inner ls-container--l">
        <div className="page__layout ls-spacing">
          {rest.kind === 'news' && header.publicationDate && (
            <PublicationMeta date={header.publicationDate} />
          )}
          {sidebar ? (
            <div className='page__grid'>
              <div className='page__content'>{children}</div>
              <div className='page__sidebar sidebar'>
                <div className='sidebar__inner'>{sidebar}</div>
              </div>
            </div>
          ) : children}
        </div>
      </div>
    </div>
  )
}
